(() => {
  const DURATION_MS = 1800;
  const FPS = 60;
  const FRAME_MS = 1000 / FPS;
  const EASING = (t) => 1 - Math.pow(1 - t, 3);

  function parseStatValue(raw) {
    const cleaned = raw.replace(/,/g, '');
    const match = cleaned.match(/^([+-]?)(\d+\.?\d*)/);
    if (!match) return null;

    const numStr = match[2];
    const value = parseFloat(numStr);
    const decimals = numStr.includes('.') ? numStr.split('.')[1].length : 0;
    const prefix = match[1] || '';
    const suffix = raw.replace(/^[+-]?[\d,.]+/, '');
    const hasCommas = raw.includes(',');

    return { value, decimals, prefix, suffix, hasCommas };
  }

  function formatNumber(n, decimals, hasCommas) {
    let str = n.toFixed(decimals);
    if (hasCommas) {
      const parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      str = parts.join('.');
    }
    return str;
  }

  function animateCounter(el, parsed) {
    const start = performance.now();
    let last = start;

    function tick(now) {
      if (now - last < FRAME_MS) {
        requestAnimationFrame(tick);
        return;
      }
      last = now;

      const elapsed = now - start;
      const progress = Math.min(elapsed / DURATION_MS, 1);
      const eased = EASING(progress);
      const current = eased * parsed.value;

      el.textContent = parsed.prefix + formatNumber(current, parsed.decimals, parsed.hasCommas) + parsed.suffix;

      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }

  function init() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.science-results').forEach((section) => {
      const statEls = section.querySelectorAll('[data-count-target]');
      if (!statEls.length) return;

      if (prefersReduced) return;

      const entries = [];
      statEls.forEach((el) => {
        const raw = el.getAttribute('data-count-target');
        const parsed = parseStatValue(raw);
        if (!parsed) return;
        el.textContent = parsed.prefix + formatNumber(0, parsed.decimals, parsed.hasCommas) + parsed.suffix;
        entries.push({ el, parsed });
      });

      if (!entries.length) return;

      let fired = false;
      const observer = new IntersectionObserver(
        (records) => {
          if (fired) return;
          for (const record of records) {
            if (record.isIntersecting) {
              fired = true;
              entries.forEach(({ el, parsed }) => animateCounter(el, parsed));
              observer.disconnect();
              break;
            }
          }
        },
        { threshold: 0.3 }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
